import { useEffect } from 'react';
import { usePatientPortalUIConfigOptions } from 'utils/patient-portal-ui-config';

/**
 * Sets the document favicon based on the active tenant (systemId).
 * The static <link rel="icon"> in index.html is a fallback; this hook
 * swaps in the tenant-specific favicon once the tenant is resolved.
 */
export const useFavicon = () => {
  const { favicon } = usePatientPortalUIConfigOptions();

  useEffect(() => {
    if (!favicon) return;

    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.type = 'image/svg+xml';
    link.href = favicon;
  }, [favicon]);
};
